import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// hooks
import useAuth from 'hooks/useAuth';
// redux
import { useSelector, useDispatch } from 'redux/store';
import { onSaveFilter } from 'redux/slices/Patient';


const IdleTimeOutHandler = () => {
    const { user, isAuthenticated, logout } = useAuth();
    const dispatch = useDispatch();
    const { allSetting } = useSelector((state) => state.all);
    const timeOutInterval = parseInt(allSetting?.SRI_PARAM?.SESSION_LIFETIME.valeur, 10);
    //  const maxTimeOutInterval = parseInt(allSetting?.SRI_PARAM?.SESSION_MAX_LIFETIME.valeur, 10);
    let timer = null;
    const navigate = useNavigate();
    // const connecteTime = window.sessionStorage.getItem('connecteTime');
    const events = ['click', 'load'];

    useEffect(() => {
        if (timeOutInterval) {
            const currentDateTime = new Date();
            const resultInSeconds = currentDateTime.getTime() / 1000;
            sessionStorage.setItem('lastInteractionTime', resultInSeconds);
            addEvents();
        }
        return (() => {
            removeEvents();
            clearTimeout(timer);

        });
        // eslint-disable-next-line
    }, [timer, isAuthenticated, timeOutInterval])

    const startTimer = () => {

        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(() => {
            const lastInteractionTime = sessionStorage.getItem('lastInteractionTime');

            const currentDateTime = new Date();

            const curretnDateTime = currentDateTime.getTime() / 1000;
            const diff = Math.floor(curretnDateTime - lastInteractionTime);
            if (isAuthenticated) {
                //   clearTimeout(timer)
                if (diff < timeOutInterval) {
                    startTimer();
                } else {
                    handleLogout();
                }
            }
            // 
        }, timeOutInterval * 1000);

    };

    const eventHandler = () => {
        if (timer) {
            const currentDateTime = new Date();
            const resultInSeconds = currentDateTime.getTime() / 1000;
            sessionStorage.setItem('lastInteractionTime', resultInSeconds);
            startTimer();
        }

    };


    const addEvents = () => {
        events.forEach(eventName => {
            window.addEventListener(eventName, eventHandler);
        });

        startTimer();
    };

    const removeEvents = () => {
        events.forEach(eventName => {
            window.removeEventListener(eventName, eventHandler);
        });
    };
    const handleLogout = async () => {
        try {
            dispatch(onSaveFilter(null));
            await logout(user?.usercode);

            navigate('/');
        } catch (error) {
            console.error(error);
        }
    };

    return (null);

};

export default IdleTimeOutHandler;